export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  Action["Download"] = "Download";
  return Action;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["AccountStatements"] = "Account Statements";
  return Feature;
}({});
export let Route = /*#__PURE__*/function (Route) {
  Route["Activity"] = "Activity";
  Route["CheckingSettings"] = "Checking Settings";
  return Route;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["StatementsByMonth"] = "Statements By Month";
  Target["AccountOwnershipLetter"] = "Account Ownership Letter";
  return Target;
}({});
const getEventName = (action, feature) => `${action} ${feature}`;
export function getEvent(action, unit_token, args) {
  const feature = Feature.AccountStatements;
  return {
    name: getEventName(action, feature),
    properties: {
      feature,
      applet: 'Balance',
      unit_token,
      ...args
    }
  };
}